/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */

/* action type */
import type { Action } from '../../store/state/state-manager';

export const CREATE_OBJECT = 'CREATE_OBJECT';

/* action creator */
export const createObjectAction = (actionPayload: Action['payload']) => {
  return {
    type: CREATE_OBJECT,
    payload: actionPayload
  };
};
